/* eslint-disable */
import Swiper from 'swiper/swiper-bundle';

Drupal.behaviors.carouselCentered = {
  attach(context) {
    // Locate the elements to apply swiper to.
    const carouselCentered = context.getElementsByClassName('swiperCentered');

    if (carouselCentered) {
      // Apply swiper function.
      const swiper = new Swiper('.swiperCentered', {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        },
      });
      swiper.init();
    }
  },
};
